<template>
  <div class="bg-white  ">
    <lcontainer class="mb-4">
      <div class="heading px-8 py-2 flex flex-row items-center justify-between">
        <div>
          <div class="page text-white">Growth Plan</div>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <lCrumbs class=" px-8" :breadcrumb="breadcrumbItems" />
    <div
      class="px-8 py-4 modal-title tenant-main-color my-4 font-semibold mb-2"
    >
      Edit Growth Plan
    </div>
    <div class="flex flex-wrap my-8 mx-4">
      <div class="w-full md:w-1/2">
        <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
          <div class="modal-field font-semibold">Title:</div>
          <div class="w-full sm:w-2/3 ml-auto">
            <linput
              type="text"
              name="fname"
              v-model="form.title"
              :errorMessage="errors.title"
              :error="errors.title"
              placeholder="Title of Growth Plan"
            />
          </div>
        </div>
      </div>

      <div v-if="form.prompt_type" class="w-full md:w-1/2">
        <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
          <div class="modal-field font-semibold">Prompt Type:</div>
          <div class="w-full sm:w-2/3 ml-auto">
            <lselect
              :error="errors.prompt_type"
              v-model="form.prompt_type"
              :errorMessage="errors.prompt_type"
              :editValue="form.prompt_type"
              :items="type"
              placeholder="Select Prompt Type"
            />
          </div>
        </div>
      </div>

      <div v-if="form.course_id" class="w-full md:w-1/2">
        <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
          <div class="modal-field font-semibold">Select Course:</div>
          <div class="w-full sm:w-2/3 ml-auto">
            <lselect
              :error="errors.course"
              v-model="form.course"
              :editValue="form.course_id"
              :errorMessage="errors.course"
              :items="sortCourses"
              placeholder="Select Course"
            />
          </div>
        </div>
      </div>

      <div
        class="w-full flex flex-wrap"
        v-for="(question, index) in form.questions"
        :key="index"
      >
        <div class="flex w-full flex-wrap justify-between">
          <page-header class="py-2 uppercase main-tenant-color "
            >Question {{ index + 1 }}</page-header
          >
        </div>

       <div class="flex flex-column w-full">
        <div class="modal-field font-semibold">Question Title:</div>
        <div class="w-full sm:w-2/3 ml-auto">
          <linput
            type="text"
            name="fname"
            v-model="form.questions[index].title"


            placeholder="Title of Growth Plan Question"
          />
        </div>

        <div class="modal-field font-semibold">Question Reg Id:</div>
        <div class="w-full sm:w-2/3 ml-auto">
          <linput
            type="text"
            name="fname"
            v-model="form.questions[index].reg_question_id"


            placeholder="Growth Plan Reg Qeustion Id"
          />
        </div>
      </div>
        <div class="my-4 w-full md:w-1/1">

          <main class="mx-2">
            <VueTrix  v-model="form.questions[index].question"  @trix-attachment-add="handleAttachmentChanges($event,index)"  placeholder="Enter Question" />

            <p>Activate  Auto Grading </p>

            <div class="my-2">
              <switches color="green" v-model="labels[index].showLabel">
              </switches>
              <span class="ml-4 mb-2 pb-2 font-bold">{{
                    labels[index].showLabel ? "Yes" : "No"
                  }}</span>
            </div>
              <div class="w-full sm:w-2/3  mt-3">
              <lselect
                      v-if="labels[index].showLabel"
                      v-model="form.questions[index].label_id"
                      :items="fetchAllLabels"
                      :editValue="form.questions[index].label_id"
                      placeholder="Select Label"
              />
              <div v-show="false" v-else >{{ delete form.questions[index].label_id}}</div>
            </div>
          </main>
        </div>
        <div class="flex flex-wrap justify-between">
          <p
            v-if="index > 0"
            @click="deleteQuestion(index)"
            class="mx-2 cursor-pointer text-red-500"
          >
            Remove Question
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-center items-center">
      <div class="mb-2">
        <lms-button @click="addQuestion">Add Question</lms-button>
      </div>
    </div>
    <div class="flex flex-col justify-center items-center">
      <div class="mb-2">
        <lms-button  @click="handleFormSubmit">Submit</lms-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import FormActions from "@/mixins/FormActions";
import Switches from "vue-switches";
import axios from "axios"
import { store } from "@/store/store";
import VueTrix from "vue-trix";
export default {
  mixins: [FormActions],
  data() {
    return {
      uploading:false,
      id: "",
       labels:[
      ],
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/growth-plan",
          text: "Growth Plans",
        },
        {
          disabled: true,
          to: "#",
          text: "Edit Growth Plan",
        },
      ],
      type: [
    
        {
          text: "Embedded",
          value: "embed",
        },
      ],
      errors: [],
      form: {},
    };
  },
  computed: {
    ...mapGetters(["getTenantCourses","fetchTenantLabels"]),
    sortCourses() {
      let courses = this.getTenantCourses;
      if (!courses) return [];
      let data = [];
      courses.forEach((course) => {
        let obj = {};
        obj.text = course.title;
        obj.value = course.id;
        data.push(obj);
      });
      return data;
    },
    fetchAllLabels() {
      let labels =  this.fetchTenantLabels;
      console.log(labels)
      if (!labels) return [];
      let data = [];
      labels.forEach((label) => {
        let obj = {};
        obj.text = label.label_text;
        obj.value = label.id;
        data.push(obj);
      });
      return data;
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
    lcontainer: () => import("@/components/general/container"),
    PageHeader: () => import("@/components/general/pageheader"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    Switches,
    VueTrix
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantFetchGrowthPlan", "tenantUpdateGrowthPlan","fetchLabels","fetchTenantCourses"]),
    addQuestion() {
      let question = {
        question: "",
      };
       this.form.questions.push(question);
      let new_label = {
        showLabel : false,
      }
      this.labels.push(new_label);
    },
    deleteQuestion(index) {
      this.form.questions.splice(index, 1);
        this.labels.splice(index, 1);
    },
    async handleFormSubmit() {
      this.errors = [];
      this.updateLoader(true);
      let res = await this.tenantUpdateGrowthPlan({
        id: this.$route.params.id,
        data: this.form,
      });
      this.updateLoader(false);
      if (res == true || res.status == 200 || res.status == 201) {
        this.$router.replace({ name: "tenant-growth-plan" });
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Growth Plan edited succesfully",
        });
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
      async handleAttachmentChanges(event,index){
        // this.updateLoader(true);
          const formData = new FormData();
          formData.append("asset_file", event.attachment.file);
          formData.append("sign", true);
          if(event.attachment.file){
              axios
                  .post(`${process.env.VUE_APP_API}/tenant/asset/upload-to-bucket`,formData,{
                      headers: {
                          "content-type": "multipart/form-data",
                          Authorization: `Bearer ${store.state.auth.token}`,
                      },
                  })
                  .then(res => {
                      if(event.attachment.file.type.includes('image')){
                          this.form.questions[index].has_image = true
                          this.form.questions[index].image_url =   res.data.data.file_url
                          let attributes = {
                              url: res.data.data.file_url,
                              href:  res.data.data.file_url
                          };
                          event.attachment.setAttributes(attributes);
                        //  this.updateLoader(false);

                      }
                      if(event.attachment.file.type.includes('application')){
                          this.form.questions[index].has_template = true
                          this.form.questions[index].template_url =   res.data.data.file_url
                          let attributes = {
                              url: res.data.data.file_url,
                              href:  res.data.data.file_url
                          };
                          event.attachment.setAttributes(attributes);
                          // this.updateLoader(false);

                      }
                  })
                  .catch(err => {
              this.updateLoader(false);
                    
                  })
          }
      }
  },
  async mounted() {
    this.updateLoader(true);
     await this.fetchLabels({
      type: 'growth_plan'
    })
    this.form = await this.tenantFetchGrowthPlan({ id: this.$route.params.id });
    this.form.questions.forEach(question => {
      if (question.hasOwnProperty('label_id') && question.label_id !== null){
        let new_label = {
          showLabel : true,
        }
        this.labels.push(new_label);
      }
      else{
        let new_label = {
          showLabel : false,
        }
        this.labels.push(new_label);
      }

    })
    this.updateLoader(false);
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-admin);
    }

    .modal-field {
      color: color(lms-admin);
      max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
      top: -17px;
      z-index: 2;
      right: -16px;
    }
    z-index: 1;
  }
}
</style>
